/**
 * @generated SignedSource<<236c5bbc19c0a97b31e7f8a9218125ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateMemberProfileInput = {
  firstName?: string | null | undefined;
  hidden?: boolean | null | undefined;
  lastName?: string | null | undefined;
  memberId: string;
  phoneNumber?: string | null | undefined;
  profileImage?: ImageInput | null | undefined;
};
export type ImageInput = {
  format: string;
  height: number;
  imagekitFileId?: string | null | undefined;
  imagekitPath?: string | null | undefined;
  provider?: string | null | undefined;
  publicId?: string | null | undefined;
  width: number;
};
export type ProfileUpdateFormQueryRendererQueryMutation$variables = {
  input: UpdateMemberProfileInput;
};
export type ProfileUpdateFormQueryRendererQueryMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly member: {
      readonly departmentMemberProfiles: ReadonlyArray<{
        readonly department?: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly phoneNumber: {
        readonly nationalNumber: string;
      } | null | undefined;
      readonly profileImage: {
        readonly publicId: string;
      } | null | undefined;
      readonly user: {
        readonly memberProfiles: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly onboardedAt: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type ProfileUpdateFormQueryRendererQueryMutation = {
  response: ProfileUpdateFormQueryRendererQueryMutation$data;
  variables: ProfileUpdateFormQueryRendererQueryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "GOLF"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Department",
      "kind": "LinkedField",
      "name": "department",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GolfMemberProfile",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberProfileConnection",
  "kind": "LinkedField",
  "name": "memberProfiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberProfileEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberProfile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onboardedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileUpdateFormQueryRendererQueryMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateMemberProfilePayload",
        "kind": "LinkedField",
        "name": "updateMemberProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "departmentMemberProfiles",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
              },
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileUpdateFormQueryRendererQueryMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateMemberProfilePayload",
        "kind": "LinkedField",
        "name": "updateMemberProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "departmentMemberProfiles",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
              },
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhoneNumber",
                "kind": "LinkedField",
                "name": "phoneNumber",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d2cc079a6d28878ebb5fb1a93d5ccd6d",
    "id": null,
    "metadata": {},
    "name": "ProfileUpdateFormQueryRendererQueryMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileUpdateFormQueryRendererQueryMutation(\n  $input: UpdateMemberProfileInput!\n) {\n  responsePayload: updateMemberProfile(input: $input) {\n    member {\n      departmentMemberProfiles(type: GOLF) {\n        __typename\n        ... on GolfMemberProfile {\n          department {\n            id\n            name\n          }\n        }\n        id\n      }\n      id\n      firstName\n      lastName\n      profileImage {\n        publicId: renderingKey\n      }\n      phoneNumber {\n        nationalNumber\n        id\n      }\n      user {\n        memberProfiles {\n          edges {\n            node {\n              id\n              onboardedAt\n            }\n          }\n        }\n        id\n      }\n    }\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bfa3f8ba34d8e2e08f292202dc265bf";

export default node;
